import theme from '../../../lib/theme';

const {
  animations,
  scale,
  colors,
  layers,
  font: {
    heights,
    spacings,
    families,

    ...font
  },
} = theme;

export default () => ({
  container: {
    marginLeft: `-${scale.xxxs}`,
    position: 'relative',
    overflow: 'hidden',

    '&:before': {
      content: `''`,
      display: 'block',
      position: 'absolute',
      zIndex: layers.mid,
      backgroundColor: colors.tas.secondary,
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      animation: `300ms ${animations.slideIn} cubic-bezier(0,.42,.19,.16) forwards`,
    },
  },

  inner: {
    zIndex: layers.mid,
    lineHeight: heights.s,
    letterSpacing: spacings.m,
    fontSize: font.s,
    fontFamily: families.primary,
    color: colors.black,
  },
});
